import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title }  from '@angular/platform-browser';
import { FormControl, FormGroup } from '@angular/forms';
import { ManageChildHeadersService } from './../../Common/Services/manage-child-headers.service';
import { SharedService } from './../../Common/Services/shared.service';
import { TableDataSource } from './../../Common/md-table';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Utility } from './../../Common/Services/utility';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';

@Component({
  selector: 'app-public-locations',
  templateUrl: './public-locations.component.html',
  styleUrls: ['./public-locations.component.css'],
  providers: [FeatureFlagService]
})
export class PublicLocationsComponent implements OnInit, OnDestroy {
  form: FormGroup;
  formControl: any;
  dataSource: TableDataSource | null;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  headerStatus: any;
  countries: any;
  filteredLocations: any;
  locations: any;
  countriesToShowStates: any;
  numberOfLocations: number;
  // countryFilteredOptions is produced by setDataInComboField
  countryFilteredOptions: any;

  private redirect(): void {
    window.location.assign("/ies/external/public/testing-locations");
  }

  constructor(
    private readonly featureFlags: FeatureFlagService,
    private _sharedService: SharedService,
    private _manageChildHeadersService: ManageChildHeadersService,
    public _utility: Utility,
    private titleService: Title,
  ) {
      this.form = new FormGroup(
        {
          searchCountryControl: new FormControl('')
        }
      );
      this.formControl = this.form.controls;

  }

  ngAfterContentInit() {
    //you can get to the element content here
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_PUBLIC_LOCATIONS_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_PUBLIC_LOCATIONS_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    this.countriesToShowStates = ["United States", "India"];
    this.titleService.setTitle("Red Hat Exam Scheduler - Public Locations");
    this.headerStatus = 1;
    this._manageChildHeadersService.setHeaderStatus(this.headerStatus);
    // note: subscribing is asynchronous.
    this._sharedService.getPublicLocations().subscribe( (response: any) => {
      this.locations = response.response;
      this.numberOfLocations = this.locations.length;
      this.extractCountries();
      this.generateVisibleLocations();
      this._utility.setDataInComboField('country', this.countries, this.formControl.searchCountryControl, this);
    });
  }

  ngOnDestroy(): void {
    this.featureFlags.stop();
  }

  /* Get the countries from the gathered locations.
  *
  */

  extractCountries() {
    let countries = new Array();
    let countryIds = new Array();
    for (let location of this.locations) {
      let country = {
        "id": location["countryId"],
        "name": location["country"],
      };
      if (countryIds.indexOf(location["countryId"]) == -1){
        countries.push(country);
        countryIds.push(location["countryId"]);
      }
    };
    countries.sort((a, b) => a.name.localeCompare(b.name));
    this.countries = countries;
  }


  /* When we click on search button, this function calls
  *
  */

  onSearchBtnClick() {
    this.generateVisibleLocations();
  }
    
  generateVisibleLocations() {
    let formValues = this.form.getRawValue();
    if (formValues.searchCountryControl) {
      this.filterLocations(formValues.searchCountryControl.id);
      this.filteredLocations.sort(
        (a, b) => {
          if (this.countriesToShowStates.includes(a.country)){
            if (a.state != b.state){
              return a.state.localeCompare(b.state);
            }
            return a.city.localeCompare(b.city);
          }
          else {
            return a.city.localeCompare(b.city);
          }
        }
      );
    }
  }

  filterLocations(countryId) {
    this.filteredLocations = [];
    for (let location of this.locations) {
      if (location.countryId == countryId) {
        this.filteredLocations.push(location);
      }
    }
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/public-locations/public-locations.component.ts